"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_CommandingPresence_OnAllyResurrectedEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const Registries_1 = require("../../core/state/Registries");
let Effect_CommandingPresence_OnAllyResurrectedEventHandlerScript = class Effect_CommandingPresence_OnAllyResurrectedEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.subject === event.args.allyId) {
            return;
        }
        else if (container.getCurrentHealthPercent(event.subject) <= 50) {
            return;
        }
        container.applyBuff({
            sequence,
            creatorId: event.subject,
            targetId: event.args.allyId,
            effect: new core_1.CommandingPresenceEffectArgs(),
            duration: Duration_1.Duration.Permanent
        });
    }
};
Effect_CommandingPresence_OnAllyResurrectedEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_CommandingPresence_OnAllyResurrected")
], Effect_CommandingPresence_OnAllyResurrectedEventHandlerScript);
exports.Effect_CommandingPresence_OnAllyResurrectedEventHandlerScript = Effect_CommandingPresence_OnAllyResurrectedEventHandlerScript;
